import { format } from 'date-fns';
export const getIsoStringWithoutTime = (date) => {
    const formattedDate = format(date, 'yyyy-MM-dd');
    return formattedDate;
};
